import styled from 'styled-components';
import { DEVICES } from '_constants';

export const FilterWrapper = styled.div`
  margin-left: 10px;
`;

export const TableContainer = styled.div``;
export const AuiditTabWrapper = styled.div`
  .rt-td:last-child {
    padding-left: 15px !important;
  }
`;

export const TimezoneNotice = styled.div`
  display: flex;
  gap: 3px;
  font-size: 13px;
  color: var(--grey-dark);
  margin-top: 12px;
  padding: 0 10px;
`;

export const Wrapper = styled.div`
  display: ${({ isShow }) => isShow && 'none'};
  box-sizing: border-box;
  padding-top: 15px;
  border: 1px solid var(--rgb-grey);

  /* New design: the table is its own bordered card, so this outer frame drew a second box around
     it. The 15px top padding stays -- it is what separates the card from the section title. */
  html[data-new-ui='true'] & {
    border: none;
  }

  @media ${DEVICES.tablet} {
    padding: 5px;
  }
`;

/**
 * The row count, shown in the table's toolbar beside the sort control the way every other new-UI
 * list does it. Same 14px/700 forest as modules/ListScaffold's Count, written against the tokens
 * for the import reason described below.
 */
export const Count = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: var(--text-strong);
  white-space: nowrap;
`;

/**
 * The new design's skin for the legacy <Filter /> search box when it sits in the table's toolbar.
 *
 * Deliberately written against the CSS custom properties rather than importing
 * modules/ListScaffold/styles' newUiSearchField: that module pulls assets/styles/old/global, whose
 * circular import leaves DEVICES undefined in some test environments and takes this component's
 * suite down with it. The values are the same tokens SearchWrap uses.
 */
export const ToolbarSearchWrap = styled.div`
  display: flex;
  align-items: center;
  flex: 0 1 360px;
  min-width: 240px;

  & > div:first-child,
  form {
    width: 100%;
  }
  form {
    margin-right: 0;
  }

  .form_search {
    width: 100%;
    height: 34px;
    box-sizing: border-box;
    border: 1px solid var(--grey) !important;
    border-right: none !important;
    border-radius: 8px 0 0 8px;
    background: var(--white) !important;
  }
  .form_search input {
    background: transparent !important;
  }
  .form_search:hover,
  .form_search:hover > input {
    background-color: var(--white) !important;
    border-color: var(--grey) !important;
    cursor: text;
  }

  .searchButton {
    height: 34px;
    border-radius: 0 8px 8px 0;
    background-color: var(--forest);
    color: var(--peach);
  }

  @media (max-width: 1023px) {
    flex: 1 1 auto;
    min-width: 0;

    .searchButton {
      display: none;
    }
    .form_search {
      border-right: 1px solid var(--grey) !important;
      border-radius: 8px !important;
    }
  }
`;
